(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mascottes-superposees"] && !Shopify.designMode) return;
  try {
    
(() => {
  const MANAGER_KEY =
    '__mascottesSuperposeesV5Manager';

  const ROOT_SELECTOR =
    '[data-overlay-root-v5]';

  const CONFIG_SELECTOR =
    '[data-overlay-config-v5]';

  const OVERLAY_SELECTOR =
    '[data-overlay-owner-v5]';

  /*
   * Nettoie une éventuelle ancienne instance
   * de cette version du gestionnaire.
   */
  if (
    window[MANAGER_KEY] &&
    typeof window[MANAGER_KEY].destroy === 'function'
  ) {
    window[MANAGER_KEY].destroy();
  }

  const listeners = [];

  let refreshTimer = null;
  let destroyed = false;

  /*
   * Ajoute un événement et mémorise sa référence
   * afin de pouvoir le supprimer proprement.
   */
  function addListener(
    target,
    eventName,
    handler,
    options
  ) {
    target.addEventListener(
      eventName,
      handler,
      options
    );

    listeners.push({
      target,
      eventName,
      handler,
      options
    });
  }

  /*
   * Transforme une valeur Shopify en nombre.
   */
  function getNumber(value, fallback) {
    const number = Number(value);

    return Number.isFinite(number)
      ? number
      : fallback;
  }

  /*
   * Lit les propriétaires enregistrés
   * dans un attribut de l’élément.
   */
  function getOwners(element, attributeName) {
    return new Set(
      String(
        element.getAttribute(attributeName) || ''
      )
        .split(/\s+/)
        .filter(Boolean)
    );
  }

  /*
   * Ajoute une classe CSS associée
   * à une section propriétaire.
   */
  function addOwnedClass(
    element,
    attributeName,
    className,
    ownerId
  ) {
    const owners =
      getOwners(element, attributeName);

    owners.add(ownerId);

    element.setAttribute(
      attributeName,
      Array.from(owners).join(' ')
    );

    element.classList.add(className);
  }

  /*
   * Supprime la propriété d’une section.

   * La classe est retirée seulement lorsqu’aucune
   * autre section ne l’utilise encore.
   */
  function removeOwnerFromElements(
    attributeName,
    className,
    ownerId
  ) {
    document
      .querySelectorAll(`[${attributeName}]`)
      .forEach((element) => {
        const owners =
          getOwners(element, attributeName);

        if (!owners.has(ownerId)) {
          return;
        }

        owners.delete(ownerId);

        if (owners.size === 0) {
          element.removeAttribute(attributeName);
          element.classList.remove(className);
          return;
        }

        element.setAttribute(
          attributeName,
          Array.from(owners).join(' ')
        );
      });
  }

  /*
   * Supprime les images et les classes
   * créées par une section précise.
   */
  function cleanupOwner(ownerId) {
    if (!ownerId) {
      return;
    }

    document
      .querySelectorAll(OVERLAY_SELECTOR)
      .forEach((overlay) => {
        if (
          overlay.dataset.overlayOwnerV5 === ownerId
        ) {
          overlay.remove();
        }
      });

    removeOwnerFromElements(
      'data-overlay-anchor-owners-v5',
      'overlay-target-anchor-v5',
      ownerId
    );

    removeOwnerFromElements(
      'data-overlay-overflow-owners-v5',
      'overlay-target-overflow-v5',
      ownerId
    );
  }

  /*
   * Détermine si l’élément est lui-même
   * une section de mascottes superposées.
   */
  function isOverlayHelperSection(element) {
    if (!element) {
      return false;
    }

    return Boolean(
      element.querySelector(ROOT_SELECTOR)
    );
  }

  /*
   * Recherche la section Shopify placée
   * immédiatement avant la section technique.
   */
  function findPreviousShopifySection(root) {
    const helperSection = root.closest(
      '[id^="shopify-section-"]'
    );

    if (!helperSection) {
      return null;
    }

    /*
     * Recherche d’abord un frère direct.
     */
    let candidate =
      helperSection.previousElementSibling;

    while (candidate) {
      if (
        candidate.matches(
          '[id^="shopify-section-"]'
        ) &&
        !isOverlayHelperSection(candidate)
      ) {
        return candidate;
      }

      candidate =
        candidate.previousElementSibling;
    }

    /*
     * Méthode de secours pour les thèmes
     * comportant des conteneurs intermédiaires.
     */
    const allSections = Array.from(
      document.querySelectorAll(
        '[id^="shopify-section-"]'
      )
    );

    const currentIndex =
      allSections.indexOf(helperSection);

    if (currentIndex < 0) {
      return null;
    }

    for (
      let index = currentIndex - 1;
      index >= 0;
      index -= 1
    ) {
      const previousSection =
        allSections[index];

      if (
        !isOverlayHelperSection(previousSection)
      ) {
        return previousSection;
      }
    }

    return null;
  }

  /*
   * Recherche la cible définie dans le bloc.

   * Lorsque le sélecteur est vide, la section
   * immédiatement précédente est utilisée.
   */
  function findTarget(config, root) {
    const previousSection =
      findPreviousShopifySection(root);

    const selector = String(
      config.dataset.targetSelector || ''
    ).trim();

    if (!selector) {
      return previousSection;
    }

    try {
      /*
       * Le sélecteur peut désigner directement
       * la section précédente.
       */
      if (
        previousSection &&
        previousSection.matches(selector)
      ) {
        return previousSection;
      }

      /*
       * Recherche prioritaire dans la section
       * située juste au-dessus.
       */
      if (previousSection) {
        const localTarget =
          previousSection.querySelector(selector);

        if (localTarget) {
          return localTarget;
        }
      }

      /*
       * Recherche de secours dans toute la page.
       */
      const pageTarget =
        document.querySelector(selector);

      if (pageTarget) {
        return pageTarget;
      }

      console.warn(
        `Mascottes superposées : aucun élément ne correspond au sélecteur « ${selector} ».`
      );
    } catch (error) {
      console.warn(
        `Mascottes superposées : le sélecteur CSS « ${selector} » est invalide.`,
        error
      );
    }

    return previousSection;
  }

  /*
   * Certains éléments comme img, video ou iframe
   * ne doivent pas recevoir directement un div.

   * Dans ce cas, leur conteneur parent est utilisé.
   */
  function getMountTarget(target) {
    if (!target) {
      return null;
    }

    const unsupportedTags = new Set([
      'IMG',
      'VIDEO',
      'IFRAME',
      'PICTURE',
      'SOURCE',
      'TRACK',
      'CANVAS',
      'SVG'
    ]);

    if (unsupportedTags.has(target.tagName)) {
      return target.parentElement;
    }

    return target;
  }

  /*
   * Prépare uniquement la cible choisie.

   * Contrairement à l’ancienne version,
   * aucun parent général n’est modifié.
   */
  function prepareTarget(
    target,
    ownerId,
    allowOverflow
  ) {
    if (!target) {
      return;
    }

    const computedStyle =
      window.getComputedStyle(target);

    if (computedStyle.position === 'static') {
      addOwnedClass(
        target,
        'data-overlay-anchor-owners-v5',
        'overlay-target-anchor-v5',
        ownerId
      );
    }

    if (allowOverflow) {
      addOwnedClass(
        target,
        'data-overlay-overflow-owners-v5',
        'overlay-target-overflow-v5',
        ownerId
      );
    }
  }

  /*
   * Crée l’image visible.
   */
  function createOverlay(
    config,
    target
  ) {
    const template =
      config.querySelector(
        '[data-overlay-template-v5]'
      );

    if (
      !template ||
      !template.content ||
      !template.content.firstElementChild
    ) {
      return;
    }

    const overlay =
      template.content.firstElementChild.cloneNode(
        true
      );

    const xDesktop = getNumber(
      config.dataset.xDesktop,
      50
    );

    const yDesktop = getNumber(
      config.dataset.yDesktop,
      50
    );

    const sizeDesktop = getNumber(
      config.dataset.sizeDesktop,
      120
    );

    const xMobile = getNumber(
      config.dataset.xMobile,
      50
    );

    const yMobile = getNumber(
      config.dataset.yMobile,
      50
    );

    const sizeMobile = getNumber(
      config.dataset.sizeMobile,
      90
    );

    const zIndex = getNumber(
      config.dataset.zIndex,
      30
    );

    overlay.style.setProperty(
      '--overlay-x-desktop-v5',
      `${xDesktop}%`
    );

    overlay.style.setProperty(
      '--overlay-y-desktop-v5',
      `${yDesktop}%`
    );

    overlay.style.setProperty(
      '--overlay-size-desktop-v5',
      `${sizeDesktop}px`
    );

    overlay.style.setProperty(
      '--overlay-x-mobile-v5',
      `${xMobile}%`
    );

    overlay.style.setProperty(
      '--overlay-y-mobile-v5',
      `${yMobile}%`
    );

    overlay.style.setProperty(
      '--overlay-size-mobile-v5',
      `${sizeMobile}px`
    );

    overlay.style.setProperty(
      '--overlay-z-index-v5',
      String(zIndex)
    );

    target.appendChild(overlay);
  }

  /*
   * Installe toutes les images d’une section.
   */
  function mountRoot(root) {
    if (!root || destroyed) {
      return;
    }

    const ownerId =
      root.dataset.overlaySectionId;

    if (!ownerId) {
      return;
    }

    cleanupOwner(ownerId);

    const configurations =
      root.querySelectorAll(CONFIG_SELECTOR);

    configurations.forEach((config) => {
      const selectedTarget =
        findTarget(config, root);

      const mountTarget =
        getMountTarget(selectedTarget);

      if (!mountTarget) {
        console.warn(
          'Mascottes superposées : aucune section cible trouvée. Placez cette section immédiatement sous la section à recouvrir.'
        );

        return;
      }

      const allowOverflow =
        config.dataset.allowOverflow === 'true';

      prepareTarget(
        mountTarget,
        ownerId,
        allowOverflow
      );

      createOverlay(
        config,
        mountTarget
      );
    });
  }

  /*
   * Réinstalle toutes les sections présentes
   * sur la page.
   */
  function mountAll() {
    if (destroyed) {
      return;
    }

    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach((root) => {
        mountRoot(root);
      });
  }

  /*
   * Regroupe les mises à jour rapprochées
   * pour éviter les reconstructions répétitives.
   */
  function scheduleMount(delay = 60) {
    if (destroyed) {
      return;
    }

    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        mountAll();
      });
    }, delay);
  }

  /*
   * Nettoyage lorsqu’une section est supprimée
   * ou remplacée par Shopify.
   */
  function handleSectionUnload(event) {
    const root =
      event.target.matches(ROOT_SELECTOR)
        ? event.target
        : event.target.querySelector(ROOT_SELECTOR);

    if (root) {
      cleanupOwner(
        root.dataset.overlaySectionId
      );
    }

    scheduleMount();
  }

  /*
   * Nettoyage intégral du gestionnaire.
   */
  function destroy() {
    if (destroyed) {
      return;
    }

    destroyed = true;

    window.clearTimeout(refreshTimer);

    listeners.forEach((listener) => {
      listener.target.removeEventListener(
        listener.eventName,
        listener.handler,
        listener.options
      );
    });

    listeners.length = 0;

    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach((root) => {
        cleanupOwner(
          root.dataset.overlaySectionId
        );
      });

    document
      .querySelectorAll(OVERLAY_SELECTOR)
      .forEach((overlay) => {
        overlay.remove();
      });
  }

  window[MANAGER_KEY] = {
    destroy,
    mount: scheduleMount
  };

  /*
   * Premier chargement.
   */
  if (document.readyState === 'loading') {
    addListener(
      document,
      'DOMContentLoaded',
      () => scheduleMount(0),
      { once: true }
    );
  } else {
    scheduleMount(0);
  }

  /*
   * Événements réellement nécessaires.

   * Aucun événement section:select,
   * block:select, block:deselect ou resize
   * n’est utilisé.
   */
  addListener(
    document,
    'shopify:section:load',
    () => scheduleMount()
  );

  addListener(
    document,
    'shopify:section:reorder',
    () => scheduleMount()
  );

  addListener(
    document,
    'shopify:section:unload',
    handleSectionUnload
  );
})();

  } catch(e) { console.error(e); }
})();
})();
